exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popup[data-v-bbcfae54]{min-width:230px;z-index:5}.counter-label[data-v-bbcfae54]{text-overflow:ellipsis;width:90%;display:inline-block;white-space:nowrap;overflow:hidden}.plus-icon[data-v-bbcfae54]{position:absolute;top:0;right:0;cursor:pointer;opacity:.7}.slim-line[data-v-bbcfae54]{line-height:1rem}", ""]);

// exports
